import type {
  AdminListFiatTransactionsParams,
  AdminCompleteWithdrawalFiatInput,
  AdminBackofficeFiatDepositInput,
} from '../api'
import { api } from '../api'

const adminListFiatTransactions = async (
  params: AdminListFiatTransactionsParams,
) => {
  return await api.v1.adminListFiatTransactions(params)
}

const adminCompleteFiatWithdrawal = async (
  data: AdminCompleteWithdrawalFiatInput,
) => {
  return await api.v1.adminCompleteFiatWithdrawal(data)
}

const adminFiatDeposit = async (data: AdminBackofficeFiatDepositInput) => {
  return await api.v1.adminFiatDeposit(data)
}

export default {
  adminListFiatTransactions,
  adminCompleteFiatWithdrawal,
  adminFiatDeposit,
}
